import React from "react";
import { Paper, RaisedButton } from "material-ui";
import { Link } from "react-router";

import WorkingIndicator from "./partials/working-indicator.jsx";
import SelectWells from "./partials/select-wells.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import UserStore from "../stores/UserStore";

import MovieIcon from "material-ui/svg-icons/av/movie";
import AccountBalanceIcon from "material-ui/svg-icons/action/account-balance";
import CakeIcon from "material-ui/svg-icons/social/cake";

import { intersperse } from "../util";

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.getStyles = this.getStyles.bind(this);
  }

  static contextTypes = {
    isLarge: React.PropTypes.bool,
    router: React.PropTypes.object
  };

  static getStores() {
    return [UserStore, EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      eventBuckets: EventBucketStore.getEventBuckets(),
      isFetchingEventBuckets: EventBucketStore.getState().isFetchingAll
    };
  }

  componentWillMount() {
    this.componentWillReceiveProps();
  }

  componentDidMount() {
    window.Intercom("boot", {
      app_id: "oj5vkp3b"
    });
  }

  componentWillReceiveProps() { }

  getStyles() {
    let { isLarge } = this.context;

    return {
      img: {
        height: 35
      },
      content: {
        maxWidth: 600,
        padding: 20,
        textAlign: "center",
        margin: isLarge ? "10vh auto 0" : "10px auto 0",
        borderRadius: 10
      },
      jump: {
        margin: "20px -20px -20px",
        backgroundColor: "#f1f1f1",
        padding: 10,
        borderRadius: "0 0 10px 10px"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      { eventBuckets, isFetchingEventBuckets } = this.props;

    if (UserStore.getUserType() === "content_creator") {
      return (
        <div style={styles.content}>
          <h2>
            <img
              src="/img/eventive-dark.png"
              alt="Eventive"
              style={styles.img}
            />
          </h2>
          <p style={{ fontSize: "14pt", margin: "1em 0 1.5em" }}>
            Welcome to Eventive! Your account grants you limited access to the
            Eventive Platform. What would you like to do?
          </p>
          <SelectWells
            options={[
              {
                value: "creator_hub",
                icon: MovieIcon,
                label: "Creator Hub",
                sublabel: "Upload content for other organizations"
              },
              {
                value: "revenue_sharing",
                icon: AccountBalanceIcon,
                label: "Revenue Sharing",
                sublabel: "Receive revenue from other organizations"
              },
              {
                value: "host",
                icon: CakeIcon,
                label: "Upgrade",
                sublabel: "Upgrade your account to host your own screenings"
              }
            ]}
            onChange={v => {
              if (v === "host") {
                window.open("https://eventive.org/pricing", "_blank");
                return;
              }
              this.context.router.push(`/${v}`);
            }}
          />
        </div>
      );
    }

    return (
      <Paper zIndex={2} style={styles.content}>
        <h2>
          <img src="/img/eventive-dark.png" alt="Eventive" style={styles.img} />
        </h2>
        <p>
          Welcome to the Eventive Dashboard! Have you checked out our{" "}
          <a href="https://help.eventive.org" target="_blank">
            Help Center
          </a>{" "}
          lately? It's filled with guides and resources for making your events a
          success.
        </p>
        {isFetchingEventBuckets ? (
          <WorkingIndicator />
        ) : eventBuckets.length === 0 ? (
          <div>
            <RaisedButton
              label="Create your first event bucket"
              primary={true}
              // href="https://help.eventive.org/getting-started/create-your-first-event-bucket"
              // target="_blank"
              onTouchTap={() =>
                this.context.router.push(`/event_buckets/new?force=true`)
              }
            />
          </div>
        ) : (
          <div>
            <div>
              <RaisedButton
                label="Ask us a question right now"
                onTouchTap={() => Intercom("showNewMessage")}
              />
            </div>
            <div style={styles.jump}>
              <strong>Jump to:</strong>{" "}
              {intersperse(
                eventBuckets
                  .filter(b => b.mode !== "archived")
                  .map(b => {
                    return <Link key={b.id} to={`/event_buckets/${b.id}`}>{b.name}</Link>;
                  }),
                " · "
              )}
            </div>
          </div>
        )}
      </Paper>
    );
  }
}

export default connectToStores(Welcome);


// WEBPACK FOOTER //
// ./src/app/components/welcome.jsx